








import { Component, Prop, Vue } from 'vue-property-decorator'
import { Getter } from 'vuex-class'
import Route from '@/routes'
import * as t from '@/types'

import progressBar from '@/components/progressBar.vue'

@Component({
  components: { progressBar }
})
export default class Header extends Vue {
  @Getter annualIncome!: number
  @Getter annualExpenses!: number

  shouldShowProgressBar () {
    return this.$router.currentRoute.name !== Route.home
  }

  get nextPage () {
    return Route.step1
  }

  get label () {
    return this.$router.currentRoute.name === Route.home ? 'Let\'s Start' : 'Next Step'
  }

  get incomeString () { return `${t.currencySymbol}${this.annualIncome} Income` }
  get expensesString () { return `${t.currencySymbol}${this.annualExpenses} Expenditure` }

  get progressBarStyle () {
    const divisor = Math.max(1, this.annualIncome + this.annualExpenses)
    const percentage = 100 * this.annualExpenses / divisor
    return { width: `${percentage}%` }
  }
}
